import React, { useState, useEffect } from 'react';
import styles from './Disclaimer.module.scss';
import { Container, Row, Col, Form } from 'react-bootstrap';
import disclaimerOptions from './disclaimerOptions';

export type DisclaimerEntryProps = {
  disclaimer: any;
  onValueChange: any;
};

const Disclaimer = ({ disclaimer, onValueChange}: DisclaimerEntryProps) => {
  const [disclaimerContent, setDisclaimerContent] = useState();
  useEffect(() => {
    if (disclaimer.state === 'CA') {
      setDisclaimerContent(disclaimerOptions.ca);
    } else {
      setDisclaimerContent(disclaimerOptions.other);
    }
  }, [disclaimer]);

  return (
    <Container className={styles.Disclaimer} data-testid="Disclaimer">
      <Row>
        <Col>
          <Form.Check
            name='disclaimer'
            type={'checkbox'}
            id={'disclaimerConfirmation'}
            value={disclaimer}
            label={'By clicking the submit button, I agree to terms & conditions.'}
            className={styles.DisclaimerLabel}
            onChange={(event) => onValueChange(event.target.checked)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={styles.DisclaimerContentBox}>{disclaimerContent}</div>
        </Col>
      </Row>
    </Container>
  );
};

export default Disclaimer;
